import { FC, PropsWithChildren, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useBreakpoints } from '@mopla/utils';

import { BottomSlider } from '../../../molecules/BottomSlider/BottomSlider';
import { Footer } from '../../../molecules/MainWithFooterTemplate/Footer';
import { MainWithFooterTemplate } from '../../../molecules/MainWithFooterTemplate/MainWithFooterTemplate';
import { MplPaper } from '../../../molecules/MplPaper/MplPaper';
import { MplModal } from '../../MplModal/MplModal';

export interface IReasonFormStepWrapperProps extends PropsWithChildren {
	isOpen: boolean;
	onCancel: VoidFunction;
	buttonsBlock?: ReactNode;
}

/** Adaptive wrapper renders the content differently for Desktop and Mobile envs */
export const ReasonFormStepWrapper: FC<IReasonFormStepWrapperProps> = ({
	children,
	isOpen,
	buttonsBlock,
	onCancel,
}) => {
	const { isMobile } = useBreakpoints();
	const { t } = useTranslation('tickets');

	if (isMobile) {
		return (
			<BottomSlider
				open={isOpen}
				title={t('cancellation_flow.reason.slider_title')}
				backgroundColor="neutral.40"
				onBack={onCancel}
				testId="BookingCancellationFlow-ReasonsStep-root-mobile"
			>
				<MainWithFooterTemplate
					content={
						<MplPaper backgroundOpacity={0} sx={{ p: 1, gap: 1.5 }}>
							{children}
						</MplPaper>
					}
					footer={<Footer background="primary.main">{buttonsBlock}</Footer>}
				/>
			</BottomSlider>
		);
	}

	return (
		<MplModal
			open={isOpen}
			testId="BookingCancellationFlow-ReasonsStep-root-desktop"
			content={
				// eslint-disable-next-line react/jsx-no-useless-fragment -- normalizes children to a single node
				<>{children}</>
			}
			buttons={buttonsBlock}
			onClose={onCancel}
		/>
	);
};
